import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResults = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 161,
	height: 120,
	viewBox: "0 0 161 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M140.638 119.765C139.199 119.99 125.259 120.03 106.979 119.982H106.926C101.803 119.969 96.3375 119.948 90.7127 119.922C90.1826 119.92 89.6503 119.918 89.1165 119.915C89.0068 119.915 88.8972 119.914 88.7876 119.913C84.2478 119.892 79.618 119.868 74.9905 119.841C73.3928 119.833 71.7966 119.823 70.2034 119.814C65.1616 119.784 60.1605 119.752 55.322 119.72C55.167 119.719 55.012 119.718 54.8578 119.717C54.3988 119.714 53.9421 119.711 53.4854 119.708C47.7902 119.67 42.3461 119.631 37.3557 119.593C37.3163 119.593 37.277 119.593 37.2369 119.593C21.297 119.475 10.0117 119.378 10.0117 119.378C-1.83 112.095 -2.42658 90.2942 4.35287 80.2462C17.3107 61.0405 -0.0765319 47.3632 7.11275 33.4105C16.73 14.7473 30.4522 34.1648 51.8234 14.7889C69.6477 -1.37303 84.0414 -2.78404 92.3179 3.38279C92.5614 3.56437 92.8026 3.74822 93.0438 3.93509C98.0517 7.82691 102.691 13.0193 108.741 16.4481C108.985 16.585 109.229 16.7197 109.477 16.8528C113.583 19.0371 118.342 19.6242 124.287 19.9949C169.126 22.7851 140.483 61.3197 149.584 77.1994C159.641 94.7459 153.607 117.743 140.639 119.765H140.638Z",
			fill: "#F1F2FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.9838 111.473C78.9694 111.47 78.955 111.467 78.9414 111.461C78.8288 111.414 78.7751 111.284 78.8212 111.172C91.0251 81.6394 101.506 60.9774 108.334 52.991C108.486 52.8139 108.595 52.6853 108.638 52.6195C108.706 52.5173 108.843 52.4893 108.945 52.5567C109.047 52.624 109.075 52.7617 109.007 52.8639C108.948 52.9531 108.843 53.0757 108.669 53.2792C101.872 61.2308 91.4161 81.8512 79.2295 111.341C79.1887 111.44 79.0844 111.494 78.983 111.474L78.9838 111.473Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.651 51.8423C111.848 52.735 108.113 54.146 107.858 53.9168C107.604 53.6876 108.617 49.8237 109.421 48.931C110.224 48.0382 111.598 47.9663 112.49 48.7706C113.383 49.5741 113.455 50.9495 112.651 51.8423Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.489 54.0816C105.724 55.2876 104.576 59.2097 104.232 59.277C103.888 59.3436 101.357 56.1365 101.123 54.9297C100.889 53.7238 101.677 52.5556 102.883 52.3211C104.088 52.0865 105.256 52.8749 105.49 54.0816H105.489Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.029 61.4978C107.801 61.4546 104.241 59.4527 104.253 59.1024C104.265 58.7522 107.959 57.0067 109.186 57.0506C110.413 57.0937 111.373 58.125 111.33 59.3529C111.286 60.5808 110.256 61.5416 109.029 61.4978Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.0151 73.2157C93.6237 75.1866 92.4185 81.939 91.8567 82.1123C91.2949 82.2863 86.4919 77.392 85.8832 75.4211C85.2745 73.4502 86.3777 71.3591 88.3475 70.75C90.3172 70.141 92.4071 71.2448 93.0158 73.2157H93.0151Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.264 84.9493C98.2078 85.0991 91.9039 82.4034 91.8616 81.8163C91.8192 81.2292 97.6664 77.6491 99.7223 77.4993C101.778 77.3495 103.566 78.8959 103.716 80.953C103.866 83.0102 102.32 84.7995 100.264 84.9493H100.264Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.9196 80.2938C88.1771 82.4826 88.5559 90.8677 87.9313 91.2263C87.3068 91.5857 80.2566 87.0371 78.9992 84.8491C77.7417 82.6604 78.4956 79.8671 80.6831 78.6089C82.8706 77.3507 85.6622 78.105 86.9196 80.2938Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.4165 95.7536C94.8948 95.6764 87.5611 91.6015 87.5831 90.8812C87.605 90.161 95.1731 86.54 97.6948 86.6164C100.216 86.6936 102.198 88.8007 102.121 91.3238C102.044 93.847 99.9382 95.83 97.4165 95.7528V95.7536Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.6228 89.8924C83.8802 92.0812 84.259 100.466 83.6345 100.825C83.0099 101.184 75.9598 96.6358 74.7023 94.4478C73.4449 92.259 74.1987 89.4657 76.3862 88.2075C78.5737 86.9494 81.3653 87.7037 82.6228 89.8924Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.1206 105.352C90.5989 105.275 83.2652 101.2 83.2872 100.479C83.3091 99.7591 90.8772 96.1382 93.3989 96.2146C95.9206 96.2917 97.9024 98.3988 97.8253 100.922C97.7489 103.445 95.6423 105.428 93.1206 105.351V105.352Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.1351 101.644C76.1306 103.188 79.673 110.797 79.2322 111.366C78.7914 111.936 70.5413 110.418 68.5458 108.874C66.5504 107.33 66.1837 104.46 67.7277 102.463C69.271 100.466 72.1397 100.1 74.1351 101.644Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.2151 114.88C86.704 115.119 78.9181 111.994 78.8501 111.276C78.782 110.559 85.8382 106.02 88.3493 105.781C90.8605 105.542 93.0903 107.385 93.3292 109.897C93.5682 112.41 91.7262 114.641 89.2151 114.88Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.636 60.0419C101.874 61.2676 100.708 65.2524 100.358 65.3205C100.009 65.3886 97.4376 62.1293 97.2001 60.9037C96.962 59.678 97.7627 58.4917 98.9876 58.2534C100.213 58.0151 101.398 58.8163 101.636 60.0419H101.636Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.064 67.6368C103.817 67.5929 100.199 65.5592 100.212 65.2029C100.225 64.8465 103.977 63.0739 105.224 63.1185C106.47 63.1624 107.446 64.2102 107.402 65.4578C107.358 66.7054 106.311 67.6814 105.064 67.6375V67.6368Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.3713 65.5091C97.8507 67.2167 96.6643 72.9946 96.1774 73.1316C95.6904 73.2685 91.6701 68.9545 91.1907 67.2462C90.7113 65.5386 91.7064 63.7652 93.413 63.2855C95.1196 62.8058 96.8919 63.8015 97.3713 65.5091Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.04 76.3845C101.269 76.3218 96.1291 73.4324 96.1465 72.927C96.1647 72.4209 101.495 69.9022 103.267 69.965C105.039 70.0278 106.424 71.516 106.362 73.2887C106.299 75.0613 104.812 76.4473 103.04 76.3845Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.7267 111.545C46.7411 111.542 46.7562 111.539 46.7706 111.533C46.8863 111.485 46.9407 111.353 46.8931 111.237C34.4245 81.0646 23.7162 59.9547 16.7409 51.795C16.5859 51.6135 16.474 51.4833 16.4294 51.4152C16.3606 51.3108 16.2199 51.2821 16.1163 51.3509C16.012 51.4198 15.9833 51.5597 16.0521 51.6641C16.1118 51.7549 16.2192 51.8805 16.3969 52.0886C23.3419 60.2127 34.0238 81.2802 46.4749 111.409C46.5165 111.511 46.6231 111.565 46.7267 111.545V111.545Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3294 50.6209C13.1506 51.5325 16.9653 52.9746 17.2261 52.7408C17.4862 52.5062 16.4511 48.5592 15.6299 47.6468C14.8095 46.7351 13.4046 46.661 12.4935 47.4826C11.5824 48.3035 11.5083 49.7092 12.3294 50.6209Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6471 52.9095C19.4082 54.1419 20.5802 58.1488 20.9318 58.2176C21.2834 58.2857 23.8686 55.009 24.1083 53.7765C24.3472 52.5441 23.5427 51.3509 22.3109 51.1119C21.0792 50.8728 19.8868 51.6778 19.6478 52.9102L19.6471 52.9095Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.03 60.4857C17.2836 60.4411 20.9214 58.3961 20.9093 58.0382C20.8964 57.6804 17.1233 55.8971 15.8697 55.9417C14.616 55.9864 13.6353 57.0395 13.6791 58.2939C13.7238 59.5483 14.7763 60.5296 16.03 60.4857Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.3909 72.458C31.7686 74.4712 33.0003 81.3704 33.575 81.5475C34.1497 81.7253 39.0562 76.7243 39.6785 74.7111C40.3 72.6978 39.1734 70.5613 37.1613 69.9386C35.1493 69.3167 33.014 70.444 32.3917 72.4572L32.3909 72.458Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.986 84.4458C27.0865 84.5987 33.5273 81.8447 33.5704 81.2448C33.6142 80.6448 27.64 76.9868 25.5395 76.8339C23.439 76.6811 21.6122 78.2608 21.4594 80.3626C21.3067 82.4644 22.8855 84.2923 24.986 84.4451V84.4458Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.6197 79.6899C37.335 81.9256 36.9479 90.493 37.5861 90.86C38.2242 91.2269 45.4271 86.58 46.7118 84.3444C47.9964 82.1087 47.226 79.2541 44.9916 77.9687C42.7572 76.6833 39.9043 77.4542 38.6197 79.6899Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.8949 95.4848C30.471 95.4061 37.9642 91.2427 37.9416 90.5073C37.9189 89.7719 30.1867 86.0715 27.6106 86.1502C25.0344 86.2288 23.0095 88.3821 23.0882 90.9597C23.1668 93.5374 25.3187 95.5635 27.8949 95.4848Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.0093 89.4966C41.7247 91.7322 41.3375 100.3 41.9757 100.667C42.6139 101.034 49.8168 96.3867 51.1014 94.151C52.3861 91.9153 51.6156 89.0608 49.3812 87.7754C47.1469 86.4899 44.294 87.2609 43.0093 89.4966Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.2835 105.291C34.8597 105.213 42.3529 101.049 42.3302 100.314C42.3075 99.5785 34.5754 95.8781 31.9992 95.9568C29.4231 96.0355 27.3982 98.1887 27.4768 100.766C27.5555 103.344 29.7074 105.37 32.2835 105.291Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.6801 101.503C49.6416 103.081 46.022 110.854 46.4719 111.437C46.9218 112.019 55.3511 110.468 57.3904 108.89C59.4289 107.312 59.8032 104.379 58.2267 102.34C56.6502 100.3 53.7187 99.9253 51.6801 101.503Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.2733 115.026C38.8388 115.271 46.7933 112.077 46.8628 111.344C46.9324 110.611 39.7235 105.973 37.1572 105.729C34.5916 105.484 32.3134 107.368 32.0692 109.935C31.8249 112.502 33.707 114.781 36.2725 115.026L36.2733 115.026Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5831 58.9992C23.3404 60.2513 24.5313 64.3225 24.8882 64.3921C25.2451 64.4617 27.8727 61.132 28.1154 59.8799C28.3581 58.6277 27.5407 57.4157 26.2893 57.1721C25.0379 56.9292 23.8266 57.7471 23.5831 58.9992Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0815 66.7581C21.3556 66.7127 25.0515 64.6351 25.0387 64.2712C25.0258 63.9073 21.1923 62.0961 19.9182 62.1415C18.6441 62.1869 17.6475 63.2567 17.6929 64.5315C17.7383 65.8063 18.8074 66.8035 20.0815 66.7581Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9406 64.5844C27.4506 66.329 28.6627 72.2326 29.1602 72.3725C29.6577 72.5125 33.765 68.1047 34.255 66.3601C34.745 64.6154 33.7287 62.8034 31.9851 62.3131C30.2415 61.8229 28.4305 62.8397 27.9406 64.5844Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1495 75.6961C23.9597 75.6318 29.2103 72.6804 29.1921 72.1637C29.174 71.6469 23.7276 69.0738 21.9174 69.1374C20.1072 69.2017 18.6917 70.7217 18.756 72.5329C18.8203 74.3441 20.3393 75.7604 22.1495 75.6961Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.4443 112.768C85.4443 112.768 70.3542 88.8052 115.388 69.9741C115.388 69.9741 116.127 120.269 85.4443 112.768Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.443 69.8931L84.0922 109.463C81.7634 102.302 80.4046 84.5449 115.443 69.8931Z",
			fill: "#89B4FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.4163 107.873C85.3989 107.873 85.3808 107.867 85.3664 107.856C85.3316 107.829 85.3256 107.778 85.3536 107.743L115.381 69.844C115.409 69.8092 115.459 69.8031 115.494 69.8311C115.528 69.8584 115.534 69.9091 115.507 69.9439L85.4798 107.843C85.464 107.863 85.4405 107.873 85.4171 107.873H85.4163Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.7681 89.7583C99.7295 89.7583 99.6955 89.7303 99.6887 89.691C99.6811 89.6471 99.7106 89.6055 99.7552 89.5987L112.999 87.385C113.042 87.3774 113.084 87.4076 113.091 87.4508C113.099 87.4947 113.069 87.5363 113.025 87.5431L99.7817 89.7568C99.7771 89.7576 99.7726 89.7583 99.7681 89.7583Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.061 108.757L122.058 108.759C121.924 108.899 116.2 114.849 108.974 118.908C108.973 118.908 108.971 118.909 108.971 118.91C108.301 119.286 107.619 119.645 106.927 119.982C101.803 119.968 96.3379 119.948 90.7131 119.922C90.183 119.92 89.6507 119.918 89.1169 119.915C87.7581 118.837 86.4856 117.399 85.3347 115.537C85.334 115.536 85.334 115.536 85.334 115.536C85.334 115.536 89.6606 95.7437 122.06 108.757H122.061Z",
			fill: "#89B4FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.335 115.536C85.335 115.536 85.335 115.536 85.3357 115.537C85.3365 115.538 85.3365 115.54 85.338 115.542C85.3947 115.673 86.4064 117.955 88.7882 119.913C88.8978 119.914 89.0075 119.915 89.1171 119.915C89.6509 119.918 90.1825 119.92 90.7133 119.922C96.3382 119.948 101.803 119.968 106.927 119.982H106.979C107.625 119.658 108.289 119.301 108.971 118.91C108.972 118.909 108.973 118.909 108.975 118.908C112.77 116.725 117.111 113.463 122.059 108.759L122.061 108.757L85.335 115.536Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.6828 113.113C65.6828 113.113 77.0157 95.1175 43.1955 80.9756C43.1955 80.9756 42.6405 118.746 65.6828 113.113Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.1533 80.915L66.6977 110.632C68.4466 105.254 69.4674 91.9179 43.1533 80.915Z",
			fill: "#89B4FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.7037 109.437C65.7166 109.437 65.7302 109.433 65.7415 109.424C65.768 109.404 65.7718 109.365 65.7513 109.34L43.2013 80.8774C43.1809 80.8509 43.1423 80.8471 43.1166 80.8675C43.0901 80.888 43.0864 80.9265 43.1068 80.9523L65.6568 109.415C65.6689 109.43 65.6863 109.437 65.7045 109.437H65.7037Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.9258 95.8338C54.9545 95.8338 54.9803 95.8127 54.9855 95.7831C54.9908 95.7499 54.9689 95.7188 54.9356 95.7135L44.9903 94.0506C44.9578 94.0453 44.926 94.0672 44.9207 94.1005C44.9154 94.1338 44.9373 94.1648 44.9706 94.1701L54.916 95.8323C54.916 95.8323 54.9228 95.8331 54.9258 95.8331V95.8338Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.7508 111.204C62.7508 111.204 62.7501 111.205 62.7501 111.205C60.6329 115.455 57.9154 118.16 54.8583 119.718C54.3994 119.715 53.9427 119.712 53.486 119.709C47.7908 119.671 42.3467 119.631 37.3562 119.594C36.123 119.162 34.9041 118.671 33.7117 118.139C24.2086 113.905 16.3562 107.109 16.1649 106.943C16.1634 106.942 16.1626 106.941 16.1611 106.94C55.0973 87.0064 62.7508 111.205 62.7508 111.205V111.204Z",
			fill: "#89B4FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1611 106.939C16.1611 106.939 16.1634 106.942 16.1649 106.942C16.1672 106.944 16.1687 106.945 16.171 106.948C16.174 106.95 16.1763 106.952 16.1793 106.954C22.9119 112.272 28.7159 115.852 33.7117 118.139C34.9343 118.698 36.1101 119.181 37.2382 119.592C37.2776 119.593 37.3169 119.593 37.357 119.593C42.3474 119.63 47.7915 119.669 53.4867 119.708C53.9427 119.711 54.3994 119.714 54.8591 119.717C55.0141 119.718 55.1691 119.719 55.3233 119.719C60.8786 116.786 62.685 111.406 62.7485 111.209C62.7493 111.207 62.7501 111.206 62.7501 111.205C62.7508 111.204 62.7508 111.203 62.7508 111.203L16.1611 106.938V106.939Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.7568 58.8228C71.7568 58.8228 88.7266 70.3166 100.082 68.6318C107.169 67.5801 100.394 37.5767 100.394 37.5767L95.463 37.65C95.463 37.65 96.4838 58.8349 94.7802 58.5254C93.708 58.3302 80.6096 50.3022 80.6096 50.3022L71.7568 58.8228Z",
			fill: "#F18B7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.5663 19.7859C65.2555 20.0507 64.9591 20.3322 64.6801 20.6302C62.3845 23.0755 62.5319 27.3274 59.3471 28.9775C57.0689 30.1578 54.337 29.1652 51.7782 28.979C49.8909 28.8413 47.9288 29.1879 46.3394 30.2138C44.75 31.2404 43.5856 33.0017 43.5289 34.8939C43.4737 36.7521 44.4385 38.4967 44.595 40.3488C44.7379 42.0368 44.1685 43.7738 43.054 45.0494C41.8631 46.4128 40.1565 47.1989 38.7494 48.3375C37.3422 49.4761 36.1732 51.298 36.7207 53.0245C37.3082 54.8751 39.5584 55.7239 40.3577 57.4928C41.2174 59.3956 40.1308 61.5473 39.3452 63.4818C38.5603 65.4164 38.2919 68.0886 40.0733 69.1766C40.8643 69.6593 41.851 69.6638 42.7735 69.5768C43.3822 69.5201 44.0294 69.4361 44.5776 69.7069C44.908 69.8704 45.1674 70.148 45.4003 70.4348C46.79 72.1431 47.6966 74.4998 49.7707 75.239C50.8421 75.6211 52.0202 75.4735 53.1468 75.3139C55.5007 74.9803 57.977 74.5566 59.8038 73.0336C62.9727 70.3916 63.0945 65.4353 65.8385 62.3545C68.0244 59.9002 71.489 59.0634 74.7593 58.7434C78.0295 58.4241 93.6164 60.8369 92.2614 50.5353C91.897 47.7648 88.3121 45.6751 87.7526 42.9378C87.2989 40.7203 88.1329 38.5724 88.1647 36.3647C88.1957 34.2009 87.1938 32.0749 86.3386 30.1237C84.6079 26.1774 81.8072 20.3965 77.9184 18.2198C74.0629 16.0621 68.8531 16.9828 65.5663 19.7844V19.7859Z",
			fill: "#FF6760"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.7137 119.922C85.5614 119.899 80.2746 119.871 74.9915 119.841C74.9718 118.435 74.804 107.276 74.2384 107.135C73.6743 106.994 70.6173 118.279 70.2045 119.813C64.5214 119.779 58.8912 119.744 53.4864 119.707C53.0456 117.208 50.1814 98.4553 61.1301 87.2534L72.1228 87.9336L83.1524 87.2534C83.1524 87.2534 87.8419 92.9376 89.9576 99.5901C91.9893 105.979 90.8112 118.908 90.7145 119.922H90.7137Z",
			fill: "#170B77"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.1526 84.3051V87.2534C83.1526 87.2534 77.5618 92.6962 61.1296 87.2534L61.0918 84.3051L75.5218 83.3979L83.1526 84.3051Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.5659 48.7462C77.5659 48.7462 83.1001 49.9938 86.055 52.0343C88.1691 53.4945 92.7664 56.9028 92.7664 56.9028L87.7676 64.8227C87.7676 64.8227 89.0455 69.7911 84.0566 72.2847L83.153 84.3044C83.153 84.3044 73.7845 89.7472 61.0922 84.3044C61.0922 84.3044 59.6033 78.4266 57.9209 71.3784C56.5645 65.6935 54.6129 59.3042 56.8412 54.1777C59.722 47.5493 69.5502 48.2302 69.5502 48.2302L77.5667 48.7455L77.5659 48.7462Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5576 31.9177C82.5576 31.9177 83.3447 30.7458 83.9572 31.2292C85.5186 32.4602 83.8098 34.0702 82.761 34.4121L82.5576 31.9185V31.9177Z",
			fill: "#ED806E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.7671 17.57C67.9604 17.8522 64.0618 21.7592 63.776 26.5687C63.6822 28.1499 63.9756 29.654 64.5654 30.9984C65.8659 34.3478 66.9419 37.0472 68.2878 39.0159C69.6526 41.0117 70.2674 43.4252 69.9105 45.8167L69.5498 48.2317C75.1104 51.059 77.5663 48.7469 77.5663 48.7469L77.6056 42.7019C83.644 42.021 82.9129 30.8736 82.934 27.5802L82.925 27.5818C82.9303 27.4584 82.9363 27.3351 82.9371 27.2103C82.9726 21.6986 78.3564 17.2424 72.7679 17.5708L72.7671 17.57Z",
			fill: "#FFA089"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.9477 27.2692C70.2486 29.2522 68.443 31.1958 67.1697 33.4678C67.0283 33.7175 66.0294 35.5968 66.313 35.8154C64.7652 34.6223 63.7799 32.8504 62.952 31.0793C61.5168 28.0099 61.9652 24.3359 63.7626 21.5154C65.5395 18.7267 68.5012 17.2907 71.7511 17.0471C75.2368 16.7861 79.0303 17.9807 81.1407 20.9041C83.1217 23.6482 83.1905 27.102 83.3985 30.3424C83.1648 26.7048 78.2969 23.9607 75.3775 22.6579C75.4621 22.6957 73.1786 25.7848 73.0577 25.9361C72.697 26.3855 72.325 26.8281 71.9469 27.2692H71.9477Z",
			fill: "#FF6760"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.4726 33.7063C67.3199 33.3954 67.0515 33.1563 66.7301 33.0247C66.07 32.7531 64.9041 32.4542 64.0958 33.2516C62.9101 34.4228 65.2594 37.5618 67.611 36.0245C67.611 36.0245 68.2847 35.3595 67.4719 33.7063H67.4726Z",
			fill: "#FFA089"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.9693 31.998C81.017 31.538 80.6827 31.1264 80.223 31.0787C79.7633 31.0311 79.352 31.3655 79.3043 31.8255C79.2567 32.2855 79.5909 32.6971 80.0506 32.7447C80.5104 32.7924 80.9217 32.458 80.9693 31.998Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.065 32.8334C73.1127 32.3734 72.7785 31.9619 72.3187 31.9142C71.859 31.8665 71.4477 32.2009 71.4 32.6609C71.3524 33.1209 71.6866 33.5325 72.1463 33.5802C72.6061 33.6278 73.0174 33.2934 73.065 32.8334Z",
			fill: "#080435"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8454 29.2614C78.7577 29.2137 78.6904 29.1297 78.6692 29.0246C78.6307 28.8362 78.7524 28.6523 78.9407 28.6138C78.9966 28.6024 80.332 28.3399 81.6809 29.1449C81.8465 29.2432 81.9002 29.4566 81.8019 29.6223C81.7036 29.788 81.4836 29.8402 81.3248 29.7433C80.2087 29.0775 79.0904 29.2939 79.0791 29.2954C78.9959 29.3121 78.9142 29.2985 78.8447 29.2606L78.8454 29.2614Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8098 36.0469C77.7996 35.9032 78.1338 35.1609 78.1671 34.7327C78.1731 34.6578 78.1497 34.5837 78.1028 34.5254C77.2219 33.4367 77.324 31.8509 77.3247 31.8351C77.3361 31.6739 77.2151 31.5332 77.054 31.5218C76.8953 31.5097 76.7531 31.6308 76.741 31.7927C76.7357 31.8646 76.6246 33.526 77.5644 34.788C77.5055 35.0187 77.2642 35.5339 76.3244 35.4817C76.1595 35.4742 76.0242 35.5967 76.0151 35.7579C76.006 35.919 76.13 36.0582 76.2911 36.0673C76.4816 36.0779 76.654 36.0704 76.8098 36.0477V36.0469Z",
			fill: "#ED806E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.6963 38.1102C79.6963 38.1102 78.5462 37.458 78.125 37.5964C77.7039 37.7349 77.4944 38.263 77.4944 38.263C77.4944 38.263 77.2147 37.7599 76.6944 37.778C76.1742 37.7954 74.4873 38.8599 74.4873 38.8599C74.4873 38.8599 76.2287 40.9942 77.7886 40.6311C79.3772 40.2611 79.6963 38.1102 79.6963 38.1102Z",
			fill: "#FF6760"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.4873 38.8591C74.4873 38.8591 77.6714 38.5724 79.6963 38.1094C79.6963 38.1094 78.832 39.7738 77.6139 39.8404C76.3958 39.907 74.4873 38.8591 74.4873 38.8591Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.7673 64.9808C87.6887 64.9808 87.6206 64.9218 87.6116 64.8423C87.6078 64.8136 87.2433 61.9734 85.0468 59.9064C84.9832 59.8467 84.9802 59.7468 85.04 59.684C85.0997 59.6204 85.1995 59.6174 85.2623 59.6772C87.5443 61.8251 87.9095 64.6842 87.9238 64.8045C87.9344 64.8907 87.8732 64.9687 87.7862 64.9793C87.7794 64.98 87.7734 64.9808 87.7673 64.9808Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.3979 90.8934C73.8698 90.8934 72.626 89.6488 72.626 88.1198C72.626 86.5907 73.8698 85.3462 75.3979 85.3462C76.9261 85.3462 78.1699 86.5907 78.1699 88.1198C78.1699 89.6488 76.9268 90.8934 75.3979 90.8934ZM75.3979 86.6059C74.5639 86.6059 73.8849 87.2853 73.8849 88.1198C73.8849 88.9543 74.5639 89.6329 75.3979 89.6329C76.232 89.6329 76.911 88.9543 76.911 88.1198C76.911 87.2853 76.232 86.6059 75.3979 86.6059Z",
			fill: "#B8D0FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.744 26.3081L98.6855 27.4899V36.1496L106.744 37.1332V26.3081Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0895 36.1862C101.092 36.1862 102.715 34.2334 102.715 31.8245C102.715 29.4157 101.092 27.4629 99.0895 27.4629C97.0871 27.4629 95.4639 29.4157 95.4639 31.8245C95.4639 34.2334 97.0871 36.1862 99.0895 36.1862Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.285 25.7188L100.893 27.0299V36.6316L108.285 37.7226V25.7188Z",
			fill: "#6888D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.263 36.6726C103.1 36.6726 104.588 34.5071 104.588 31.8358C104.588 29.1645 103.1 26.999 101.263 26.999C99.4264 26.999 97.9375 29.1645 97.9375 31.8358C97.9375 34.5071 99.4264 36.6726 101.263 36.6726Z",
			fill: "#6888D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.978 21.54L110.439 23.7629V40.0511L122.978 41.901V21.54Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.068 40.12C114.184 40.12 116.71 36.4468 116.71 31.9157C116.71 27.3846 114.184 23.7114 111.068 23.7114C107.953 23.7114 105.427 27.3846 105.427 31.9157C105.427 36.4468 107.953 40.12 111.068 40.12Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.898 17.3374L124.517 20.4189V42.9974L141.898 45.5622V17.3374Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.387 43.0933C129.706 43.0933 133.208 38.0015 133.208 31.7205C133.208 25.4394 129.706 20.3477 125.387 20.3477C121.068 20.3477 117.566 25.4394 117.566 31.7205C117.566 38.0015 121.068 43.0933 125.387 43.0933Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.418 46.8784C150.382 46.8784 155.217 40.0473 155.217 31.6206C155.217 23.194 150.382 16.3628 144.418 16.3628C138.454 16.3628 133.619 23.194 133.619 31.6206C133.619 40.0473 138.454 46.8784 144.418 46.8784Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.422 16.3628L144.273 16.3643L143.699 46.8784H149.422V16.3628Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.422 46.8784C155.386 46.8784 160.221 40.0473 160.221 31.6206C160.221 23.194 155.386 16.3628 149.422 16.3628C143.458 16.3628 138.623 23.194 138.623 31.6206C138.623 40.0473 143.458 46.8784 149.422 46.8784Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.574 31.6213C157.574 34.2345 157.027 36.6556 156.093 38.6408H156.093C154.618 41.7813 152.18 43.8339 149.422 43.8339C144.92 43.8339 141.27 38.3662 141.27 31.6213C141.27 26.6158 143.28 22.3132 146.157 20.4278C146.157 20.4278 146.156 20.427 146.158 20.427C147.157 19.7726 148.261 19.4087 149.422 19.4087C153.924 19.4087 157.574 24.8765 157.574 31.6213Z",
			fill: "#6A9BE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.574 31.6213C157.574 34.2345 157.027 36.6556 156.094 38.6408H156.093C155.093 39.2952 153.99 39.6592 152.829 39.6592C148.327 39.6592 144.677 34.1914 144.677 27.4465C144.677 24.8341 145.224 22.413 146.157 20.4278C146.157 20.4278 146.157 20.427 146.158 20.427C147.157 19.7726 148.261 19.4087 149.422 19.4087C153.924 19.4087 157.574 24.8765 157.574 31.6213Z",
			fill: "#89B4FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.177 34.7543C156.137 34.7543 156.096 34.7505 156.055 34.7429C155.706 34.6763 155.476 34.3389 155.543 33.9894C155.631 33.5248 155.687 30.6884 154.864 27.8021C154.403 26.1853 153.752 24.8378 152.929 23.796C151.951 22.5568 150.72 21.754 149.273 21.409C148.927 21.3266 148.714 20.9793 148.796 20.6328C148.878 20.2863 149.226 20.0729 149.572 20.1554C152.696 20.8999 154.954 23.4215 156.102 27.448C156.956 30.4403 156.953 33.4704 156.809 34.2307C156.75 34.5394 156.48 34.7543 156.177 34.7543Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.4397 26.3081L73.3809 27.4899V36.1496L81.4397 37.1332V26.3081Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.7848 36.1862C75.7872 36.1862 77.4105 34.2334 77.4105 31.8245C77.4105 29.4157 75.7872 27.4629 73.7848 27.4629C71.7824 27.4629 70.1592 29.4157 70.1592 31.8245C70.1592 34.2334 71.7824 36.1862 73.7848 36.1862Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.9808 25.7188L75.5889 27.0299V36.6316L82.9808 37.7226V25.7188Z",
			fill: "#6888D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.9592 36.6726C77.7958 36.6726 79.2847 34.5071 79.2847 31.8358C79.2847 29.1645 77.7958 26.999 75.9592 26.999C74.1227 26.999 72.6338 29.1645 72.6338 31.8358C72.6338 34.5071 74.1227 36.6726 75.9592 36.6726Z",
			fill: "#6888D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.6746 21.54L85.1357 23.7629V40.0511L97.6746 41.901V21.54Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.7645 40.12C88.8802 40.12 91.406 36.4468 91.406 31.9157C91.406 27.3846 88.8802 23.7114 85.7645 23.7114C82.6488 23.7114 80.123 27.3846 80.123 31.9157C80.123 36.4468 82.6488 40.12 85.7645 40.12Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.593 17.3374L99.2109 20.4189V42.9974L116.593 45.5622V17.3374Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.081 43.0933C104.401 43.0933 107.902 38.0015 107.902 31.7205C107.902 25.4394 104.401 20.3477 100.081 20.3477C95.7622 20.3477 92.2607 25.4394 92.2607 31.7205C92.2607 38.0015 95.7622 43.0933 100.081 43.0933Z",
			fill: "#7798F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.114 46.8784C125.079 46.8784 129.914 40.0473 129.914 31.6206C129.914 23.194 125.079 16.3628 119.114 16.3628C113.15 16.3628 108.315 23.194 108.315 31.6206C108.315 40.0473 113.15 46.8784 119.114 46.8784Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.119 16.3628L118.699 16.3741L118.396 46.8784H124.119V16.3628Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.118 46.8784C130.083 46.8784 134.917 40.0473 134.917 31.6206C134.917 23.194 130.083 16.3628 124.118 16.3628C118.154 16.3628 113.319 23.194 113.319 31.6206C113.319 40.0473 118.154 46.8784 124.118 46.8784Z",
			fill: "#100259"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.27 31.6213C132.27 34.2345 131.723 36.6556 130.79 38.6408H130.789C129.315 41.7813 126.877 43.8339 124.118 43.8339C119.616 43.8339 115.966 38.3662 115.966 31.6213C115.966 26.6158 117.976 22.3132 120.853 20.4278C120.853 20.4278 120.853 20.427 120.854 20.427C121.853 19.7726 122.957 19.4087 124.118 19.4087C128.62 19.4087 132.27 24.8765 132.27 31.6213Z",
			fill: "#6A9BE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.27 31.6213C132.27 34.2345 131.723 36.6556 130.79 38.6408H130.789C129.789 39.2952 128.686 39.6592 127.525 39.6592C123.023 39.6592 119.373 34.1914 119.373 27.4465C119.373 24.8341 119.92 22.413 120.854 20.4278C120.854 20.4278 120.853 20.427 120.854 20.427C121.853 19.7726 122.957 19.4087 124.119 19.4087C128.621 19.4087 132.27 24.8765 132.27 31.6213Z",
			fill: "#89B4FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.873 34.7552C130.833 34.7552 130.792 34.7515 130.751 34.7439C130.402 34.6773 130.173 34.3399 130.239 33.9903C130.328 33.5258 130.384 30.6902 129.56 27.8031C129.099 26.1863 128.448 24.8388 127.625 23.797C126.647 22.5577 125.417 21.755 123.969 21.41C123.623 21.3276 123.41 20.9803 123.492 20.6338C123.575 20.2873 123.922 20.0739 124.268 20.1564C127.392 20.9009 129.65 23.4225 130.799 27.4498C131.652 30.442 131.649 33.4728 131.504 34.2324C131.445 34.5411 131.175 34.756 130.872 34.756L130.873 34.7552Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.7579 44.8316C87.7579 44.8316 90.6002 39.2829 90.5079 37.9748C90.4157 36.6667 89.6248 32.8588 89.6437 32.2263C89.6626 31.5938 90.5042 28.3648 90.2924 27.783C90.0807 27.2012 88.3454 30.9992 88.3454 30.9992C88.3454 30.9992 89.3715 27.5507 88.8142 27.1876C88.2569 26.8244 86.8362 30.4272 86.8362 30.4272C86.8362 30.4272 87.9877 26.9659 87.3957 26.804C86.8044 26.6428 85.64 29.9907 85.64 29.9907C85.64 29.9907 86.4967 27.2897 86.0241 27.1717C85.5523 27.0536 83.4381 31.3033 83.9909 33.104C85.2974 37.3567 84.4649 42.5127 84.4649 42.5127L87.7571 44.8324L87.7579 44.8316Z",
			fill: "#FFA089"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.9209 62.3069C57.9209 62.3069 72.5641 74.9765 83.959 73.5791C91.6352 72.6379 89.921 40.1196 89.921 40.1196L84.6591 40.6719C84.6591 40.6719 81.5091 63.1656 79.2853 63.1656C78.1958 63.1656 65.827 53.7591 65.827 53.7591L57.9209 62.3069Z",
			fill: "#FFA089"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.8511 51.9316L73.4816 57.6589L63.5695 69.7459L57.0947 63.1668L58.9525 57.5106L66.8511 51.9316Z",
			fill: "#2F61C7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5912 68.6224L60.2646 65.9479L60.3456 65.8163L64.5572 68.4189L73.0206 58.0985L67.8312 53.2458L67.9371 53.1323L73.233 58.0841L64.5912 68.6224Z",
			fill: "#080435"
		})
	]
});
const ForwardRef = forwardRef(SvgNoResults);
export { ForwardRef as ReactComponent };
